import { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = anon, object = authed
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;
        api.get("/auth/me")
            .then((res) => {
                if (mounted) setUser(res.data);
            })
            .catch(() => {
                if (mounted) setUser(false);
            })
            .finally(() => mounted && setLoading(false));
        return () => {
            mounted = false;
        };
    }, []);

    async function login(email, password) {
        const res = await api.post("/auth/login", { email, password });
        if (res.data?.token) localStorage.setItem("tp_token", res.data.token);
        setUser(res.data.user);
        return res.data.user;
    }

    async function logout() {
        try {
            await api.post("/auth/logout");
        } catch {
            /* ignore */
        }
        localStorage.removeItem("tp_token");
        setUser(false);
    }

    return (
        <AuthContext.Provider value={{ user, loading, login, logout, formatApiError }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used within AuthProvider");
    return ctx;
}
